// Simple Spinner Component

export const Spinner = () => {
    return (
        <div className='flex items-center justify-center h-10 aspect-squere pr-1'>
            <div className='size-6 p-1.5 border-4 border-t-transparent border-blue-500 rounded-full animate-spin'></div>
        </div>
    );
};
